export enum ExchangeCrnCreationEnum {
  AUTOMATICALLY = "automatically",
  MANUALLY = "manually",
}
